// extracted by mini-css-extract-plugin
module.exports = {"link":"user_link__12yWm","label":"user_label__2CJCi","message":"user_message__22ovu","user-name":"user_user-name__1LMaX","error":"user_error__1VbFu"};